;(function() {
/* @ngInject */
function IndexController(ModalVideo, $window, $rootScope, $filter, $translate, ModalIdle, IndexService, MojaFirmaService) {

  let vm = this;
  let indexService = IndexService;

  vm.isActive = isActive;
  vm.playVideo = playVideo;
  vm.goToPath = goToPath;
  vm.goToMojaFirma = goToMojaFirma;
  vm.openMobileMenu = false;
  vm.lang = $translate.use();

  vm.stats = [];
  vm.googleReviews = [];

  indexService.getGoogleReviews().then(data => vm.googleReviews = data);

  function goToMojaFirma(path) {
      MojaFirmaService.goToMojaFirma(path);
  }

  function playVideo(url) {
    ModalVideo(url)
      .add()
      .result
      .then();
  }

  function goToPath(path) {
    $window.location = path;
  }

  function isActive(routes) {
    let active = false;
    routes.forEach(function(route){
      if(($window.location.pathname.startsWith(route)) && $window.location.pathname !== "/zalozenie-sro-a-zivnosti"){
        active = true;
      }
    }, this);
    return active;
  }

  var showSpinner = function(promisesToResolve, callFunction) {

      window.promisesToResolve = promisesToResolve;
      window.callFunction = callFunction;

      const wait = $filter('translate')('wait');

      const spinnerTemplate = '<div style="display: block" class="loading_page"> <div> <i class="fa fa-spinner fa-spin"></i> <p>' + wait + '</p> </div> </div>';
      document.querySelector(".spinnerPlaceholder").innerHTML = spinnerTemplate;
  };

  var hideSpinnerWhenAllResolved = function() {

      //ked dorazil posledny promise
    if(window.promisesToResolve === 1){
        document.querySelector(".spinnerPlaceholder").innerHTML = "";
        window.promisesToResolve = 0;
        $rootScope.$broadcast("show-cart-price");
        if(window.callFunction)
          $rootScope.$broadcast(window.callFunction);
    }else{
        window.promisesToResolve--;
    }

  };

  window.showSpinner = showSpinner;
  window.hideSpinnerWhenAllResolved = hideSpinnerWhenAllResolved;

  $rootScope.$on('IdleTimeout', function() {
    console.log('Session expired');
    ModalIdle()
      .add()
      .result
      .then();
  });

}

angular.module("firmaren")
  .controller("IndexController", IndexController);
}());
